import React, { useState, useRef } from "react";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { Paginator } from 'primereact/paginator';
import servicioFormatos from "../../../servicio/ServicioFormatos";
import servicioObjetos from "../../../servicio/ServicioObjetos";
import servicioArchivos from '../../../servicio/ServicioArchivos';
import servicioHttp from "../../../servicio/ServicioHttp";


export const TablaResultados = (props) => {

    const { paginacion,
        inicio, cambiaPagina, funcionBusqueda } = props;

    const [mostrarElModalEliminar, setMostrarElModalEliminar] = useState(false);
    const [nombreArchivoTxt, setNombreArchivoTxt] = useState(null);
    const [mostrarElModalLiberar, setMostrarElModalLiberar] = useState(false);
    const [loteIdImss, setLoteIdImss] = useState(null);
    const [verDetalle, setVerDetalle] = useState(false);
    const [idLote, setIdLote] = useState(null);
    const [paginacionDetalle, setPaginacionDetalle] = useState({});

    let growl = useRef(null);

    const plantillaOpciones = (rowData, column) => {
        let { estado, loteIdImss } = rowData;
        return <div className="p-grid">
            {((estado === 2) && !servicioObjetos.esObjetoVacio(loteIdImss)) ? <div className="p-col-12 p-md-12">
                <Button label="Descargar .TXT" icon="pi-md-file-download"
                    onClick={() => descargarTxt(rowData)} className="p-button-warning flat-btn" />
            </div> : null}
        </div>
    }

    const descargarTxt = (rowData) => {       
        servicioArchivos.descargaArchivo("lote/individual_txt_casa_ley.json", {id:rowData.id});
    }

    const onIndexTemplate = (data, props) => {
        return (props.rowIndex + 1) + inicio;
    }

    const columnaempresa = (rowData, column) => {
        return <div>{rowData.registroPatronal} - {rowData.razonSocial} - {rowData.nombreCortoEmpresa}</div>;
    }

    const columnaFechaRecepcion = (rowData, column) => {
        return <div>{servicioFormatos.formatearFechaString(rowData.fechaRecepcionEmica)}</div>;
    }

    const columnaFechaRespuestaImss = (rowData, column) => {
        return <div>{servicioFormatos.formatearFechaString(rowData.fechaRespuestaImss)}</div>;
    }

    const columnaFechaObtencionNumeroLote = (rowData, column) => {
        return <div>{servicioFormatos.formatearFechaString(rowData.fechaObtencionNumeroLote)}</div>;
    }

    const columnaUsuario = (rowData, column) => {
        return <div>{rowData.usuario}  - {rowData.correoUsuario}</div>;
    }

    const columnaEstado = (rowData, column) => {
        return obtenerEstado(rowData);
    }

    const obtenerEstado = (rowData) => {
        let response = "";
        switch (rowData.estado) {
            case -1:
                response = <strong style={{ color: "yellow" }}>Se está enviando al IMSS</strong>;
                break;
            case 0:
                response = <strong style={{ color: "black" }}>En espera de ser enviado</strong>;
                break;
            case 1:
                response = <strong style={{ color: "blue" }} >Recibido por el IMSS,ya se cuenta con número de lote, esperando el AFIL</strong>;
                break;
            case 2:
                if (servicioObjetos.esObjetoVacio(rowData.loteIdImss)) {
                    response = <strong style={{ color: "red" }}>Enviado al IMSS con errores</strong>;
                }
                else {
                    response = <strong style={{ color: "green" }}>Recibido por el IMSS ya se cuenta con el AFIL</strong>;
                }

                break;
            default:
                response = "";

        }
        return response;
    }

    const columnaNumeroLote = (rowData, column) => {
        return <div>{servicioObjetos.esObjetoVacio(rowData.loteIdImss) ? "" : <strong>{rowData.loteIdImss}</strong>}</div>;
    }

    const descargaMasiva = () => {
        servicioArchivos.descargaArchivo("/lote/todos_txt_casa_ley.json",paginacion);
    }

    return (
        <div className="card card-w-title">
            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-4">
                    {servicioObjetos.esObjetoVacio(paginacion.datos) ? null : <Button label="Descargar todo" icon="pi-md-file-download" onClick={descargaMasiva} />}
                </div>
            </div>
            <Growl ref={growl} />
            <DataTable
                value={paginacion.datos}
                responsive={true}
                header="Empresa"
                autoLayout={true}
                selectionMode="single">
                <Column field="Index" header="Número" body={onIndexTemplate} />
                <Column header="Opciones" body={plantillaOpciones} />
                <Column field="nombreArchivo" header="Nombre del Archivo" />
                <Column header="Número de Lote" body={columnaNumeroLote} />
                <Column header="Estado" body={columnaEstado} />
                <Column header="Empresa" body={columnaempresa} />
                <Column header="Fecha Recepción en EMICA" body={columnaFechaRecepcion} />
                <Column header="Fecha obtención Número Lote" body={columnaFechaObtencionNumeroLote} />
                <Column header="Fecha de descarga Afil" body={columnaFechaRespuestaImss} />
                <Column header="Cargado por:" body={columnaUsuario} />
            </DataTable>

            <Paginator first={inicio} rows={paginacion.registrosPorPagina}
                totalRecords={paginacion.registrosTotales}
                onPageChange={cambiaPagina}
                rowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate={"Total: " + paginacion.registrosTotales + ", Página ({currentPage} de {totalPages})"} />
        </div>
    );
}